module.exports = __webpack_public_path__ + "img/huawei.2dae6cb3.png";